// Documentation link mapping for deep linking from docs to app pages
export const documentationLinks: Record<string, string> = {
  // Navigation links
  'Dashboard': '/dashboard',
  'Companies': '/crm/companies',
  'Contacts': '/crm/contacts',
  'Quotes': '/quotes',
  'Invoices': '/invoices',
  'Pipeline': '/crm/pipeline',
  'Tasks': '/reminders',
  'Reminders': '/reminders',
  'Reports': '/reports',
  'Settings': '/settings',
  
  // Actions
  'Add Company': '/crm/companies?action=new',
  'Create Company': '/crm/companies?action=new',
  'New Company': '/crm/companies?action=new',
  'Add Contact': '/crm/contacts?action=new',
  'Create Contact': '/crm/contacts?action=new',
  'New Contact': '/crm/contacts?action=new',
  'Create Quote': '/create-quote',
  'New Quote': '/create-quote',
  'Create Invoice': '/invoices/create',
  'New Invoice': '/invoices/create',
  
  // Specific pages
  'Pending Quotes': '/quotes/pending',
  'Approved Quotes': '/quotes/approved',
  'Rejected Quotes': '/quotes/rejected',
  'Active Clients': '/crm/clients/active',
  'Inactive Clients': '/crm/clients/inactive',
  'Pending Onboarding': '/crm/clients/pending-onboarding',
  'Archived Companies': '/crm/companies/archived',
  'Archived Contacts': '/crm/contacts/archived',
  'Audit Trail': '/audit',
  'Admin Users': '/admin/users',
  'Invite Users': '/admin/invite-users',
  'Data Quality': '/admin/data-quality',
  'Duplicates': '/tools/duplicates',
  'Plans & Pricing': '/plans-pricing',
  'Manage Add-ons': '/manage-addons',
  
  // CRM stages
  'Prospects': '/crm/prospects',
  'Leads': '/crm/leads',
  'Qualified': '/crm/qualified',
  'Proposals': '/crm/proposals',
  'Negotiation': '/crm/negotiation',
  'Won': '/crm/won',
  'Lost': '/crm/lost',
  
  // Client states
  'Active': '/crm/clients/active',
  'Inactive': '/crm/clients/inactive',
  'Onboarding': '/crm/clients/pending-onboarding',
  
  // Deal Pipeline
  'Deal Pipeline': '/crm/pipeline',
  
  // Pending items
  'Pending': '/quotes/pending',
  'Pending Quotes': '/quotes/pending',
  
  // Settings pages
  'Profile Settings': '/settings/profile',
  'Company Settings': '/settings',
  'Integrations': '/settings#integrations',
  'Templates': '/settings#templates',
  'Branding': '/settings#branding',
}

// Function to add hyperlinks to documentation content
export function addDocumentationLinks(content: string): string {
  let processedContent = content
  
  // Sort by length (longest first) to avoid partial matches
  const sortedLinks = Object.keys(documentationLinks).sort((a, b) => b.length - a.length)
  
  sortedLinks.forEach(term => {
    const link = documentationLinks[term]
    // Match the term when it appears in bold (**term**) or as plain text
    // But not if it's already part of a link
    const boldRegex = new RegExp(`\\*\\*${term}\\*\\*(?![\\]\\)])`, 'g')
    const plainRegex = new RegExp(`(?<!\\[|\\*\\*)\\b${term}\\b(?!\\]|\\*\\*)`, 'g')
    
    // Replace bold terms with linked bold terms
    processedContent = processedContent.replace(boldRegex, `[**${term}**](${link})`)
    
    // For plain text, only replace if it's in specific contexts (like "Navigate to X" or "Go to X")
    processedContent = processedContent.replace(
      new RegExp(`(Navigate to|Go to|Click on|Open|Visit|Access|View) ${term}(?![\\]\\)])`, 'g'),
      `$1 [${term}](${link})`
    )
  })
  
  return processedContent
}

// Function to check if a link is internal (starts with /)
export function isInternalLink(href: string): boolean {
  return href.startsWith('/') && !href.startsWith('//')
}
